<template>
	<el-dialog v-dialogDrag class="chat-record-dialog-shell im-dialog-shell im-dialog-shell--sm im-dialog-shell--mobile-center"
		custom-class="chat-record-dialog" title="语音录制"
		:visible.sync="visible" width="600px" :before-close="onClose">
		<div class="chat-record">
			<div v-show="mode == 'RECORD'" class="record-status">
				<div class="tip">{{ stateTip }}</div>
				<div class="duration">时长 {{ state == 'STOP' ? 0 : parseInt(rc.duration) }}s</div>
			</div>
			<audio v-show="mode == 'PLAY'" class="audio-player" :src="url" controls ref="audio" @ended="onStopAudio()"></audio>
			<el-divider content-position="center"></el-divider>
			<el-row class="btn-group">
				<el-button round type="primary" v-show="state == 'STOP'" @click="onStartRecord()">开始录音</el-button>
				<el-button round type="warning" v-show="state == 'RUNNING'" @click="onPauseRecord()">暂停录音</el-button>
				<el-button round type="primary" v-show="state == 'PAUSE'" @click="onResumeRecord()">继续录音</el-button>
				<el-button round type="danger" v-show="state == 'RUNNING' || state == 'PAUSE'" @click="onCompleteRecord()">
					结束录音</el-button>
				<el-button round type="success" v-show="state == 'COMPLETE' && mode != 'PLAY'" @click="onPlayAudio()">播放录音
				</el-button>
				<el-button round type="warning" v-show="state == 'COMPLETE' && mode == 'PLAY'" @click="onStopAudio()">停止播放
				</el-button>
				<el-button round type="primary" v-show="state == 'COMPLETE'" @click="onRestartRecord()">重新录音</el-button>
				<el-button round type="primary" v-show="state == 'COMPLETE'" @click="onSendRecord()">立即发送</el-button>
			</el-row>
		</div>
	</el-dialog>
</template>

<script>
import Recorder from 'js-audio-recorder';

export default {
	name: 'chatRecord',
	props: {
		visible: {
			type: Boolean
		}
	},
	data() {
		return {
			rc: new Recorder(),
			audio: new Audio(),
			state: 'STOP', // STOP、RUNNING、PAUSE、COMPLETE
			stateTip: "未开始",
			mode: 'RECORD', // RECORD 、PLAY
			duration: 0,
			url: ""
		}
	},
	methods: {
		onClose() {
			// 关闭前清除数据
			this.rc.destroy();
			this.rc = new Recorder();
			this.audio.pause();
			this.mode = 'RECORD';
			this.state = 'STOP';
			this.stateTip = '未开始';
			this.url = "";
			this.$emit("close");
		},
		onStartRecord() {
			this.rc.start().then((stream) => {
				this.state = 'RUNNING';
				this.stateTip = "正在录音...";
			}).catch(error => {
				this.$message.error(error);
			});


		},
		onPauseRecord() {
			this.rc.pause();
			this.state = 'PAUSE';
			this.stateTip = "已暂停录音";
		},
		onResumeRecord() {
			this.rc.resume();
			this.state = 'RUNNING';
			this.stateTip = "正在录音...";
		},
		onCompleteRecord() {
			this.rc.pause();
			this.state = 'COMPLETE';
			this.stateTip = "已结束录音";
		},
		onPlayAudio() {
			let wav = this.rc.getWAVBlob();
			let url = URL.createObjectURL(wav);
			this.url = url;
			this.$refs.audio.src = url;
			this.$refs.audio.play();
			this.mode = 'PLAY';
		},
		onStopAudio() {
			this.$refs.audio.pause();
			this.mode = 'RECORD';
		},
		onRestartRecord() {
			this.rc.destroy();
			this.rc = new Recorder()
			this.rc.start();
			this.state = 'RUNNING';
			this.mode = 'RECORD';
			this.stateTip = "正在录音...";
			this.url = "";
		},
		onSendRecord() {
			let wav = this.rc.getWAVBlob();
			let name = new Date().getDate() + '.wav';
			const file = new File([wav], name, {
				type: wav.type || 'audio/wav'
			});
			const localUrl = this.url || URL.createObjectURL(wav);
			let data = {
				duration: parseInt(this.rc.duration),
				file,
				localUrl
			}
			this.$emit("send", data);
			this.onClose();
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-record {
	display: grid;
	gap: 10px;

	.record-status {
		display: grid;
		gap: 6px;
		padding: 18px 16px;
		border-radius: 16px;
		background: rgba(var(--im-primary-rgb), 0.05);
		text-align: center;
	}

	.tip {
		font-size: 18px;
		font-weight: 600;
		color: var(--im-text-color);
	}

	.duration {
		font-size: 13px;
		color: var(--im-text-color-light);
	}

	.audio-player {
		width: 100%;
	}

	.btn-group {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		justify-content: center;
		margin-bottom: 0;
	}

	::v-deep .el-button {
		margin: 0;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}
}

.chat-record-dialog-shell {
	::v-deep .chat-record-dialog {
		width: min(420px, calc(100vw - 24px)) !important;
	}
}
</style>
